import styled from 'styled-components'

const Header = styled.div`
  min-height: 100px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 120px;
  max-width: 250px;
`

export default Header
